export default __webpack_public_path__ + "static/media/Reading-hover.dc19bbc8.svg";